module.exports = __webpack_public_path__ + "img/全局美颜--大图--美颜后.df33214a.png";